import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from "react-translator-component";
import { faConciergeBell, faClipboardCheck, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { isHostz, isHostzArosa, isHostzBlackSummit, isHostzMyde, isSimplex } from "../../components/CheckIn/hotelConditions";


const ButtonPanel = ({ hotel, checkInId, pathname, hasUpsells }) => {

    const showServicesButton = !isHostz(hotel.id) && !isSimplex(hotel.id)
    
    return (
        <div className="mx-2 mt-4 button-panel-vico" style={{ position: "relative" }}>
            <div
                className="d-block py-1 mb-3 d-flex align-items-center"
                style={{
                    boxShadow: "1px 4px 15px rgba(0,0,0,0.20)",
                    background: "#FFF",
                    borderRadius: 8,
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 2,
                    paddingRight: 2,
                    color: "#444",
                    justifyContent: "space-evenly",
                    height: 50
                }}
            >
                <NavLink
                    to={`/${hotel.code}/stay`}
                    state={{ from: pathname }}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#444",
                        textDecoration: "none",
                        padding: "0px 10px",
                        borderRadius: 8,
                    }}
                >
                    <FontAwesomeIcon icon={faClipboardCheck} size="lg" style={{ marginRight: 6, marginTop: -2 }} />
                    <span>{T("general.stay")}</span>
                </NavLink>
                {showServicesButton && (<>
                    <div className="border-left" style={{ height: 30 }}></div>
                    <NavLink
                        to={`/${hotel.code}/services`}
                        state={{ from: pathname }}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#988460",
                            textDecoration: "none",
                            // paddingTop: "10px",
                            padding: "0px 10px",
                            borderRadius: 8
                        }}
                    >
                        <FontAwesomeIcon icon={faConciergeBell} size="lg" style={{ marginRight: 6, marginTop: -2 }} />
                        <span>{T("general.services")}</span>
                    </NavLink>
                </>)}
                {hasUpsells /* && (!isHostzBlackSummit(hotel.id) || checkInId === "988f9aa1-fd53-4224-a230-9f444de4e284") */ && (
                    <>
                        <div className="border-left" style={{ height: 30 }}></div>
                        <NavLink
                            to={`/${hotel.code}/services/service_upselling`}
                            state={{ from: pathname }}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#444",
                                textDecoration: "none",
                                padding: "10px 10px",
                                borderRadius: 8,
                            }}
                        >
                            <FontAwesomeIcon icon={faPlusCircle} size="lg" style={{ marginRight: 6, marginTop: -2 }} />
                            <span>{T("cups.title")}</span>
                        </NavLink>
                    </>
                )}
            </div>
        </div>
    );
};

export default ButtonPanel;
